import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ts1 from "../../../../../assets/images/accessoires/gf.webp";
import ts2 from "../../../../../assets/images/accessoires/simex.webp";
import ts3 from "../../../../../assets/images/accessoires/manitou.webp";

import SectionTitle from "../../../../Shared/SectionTitle/SectionTitle";

import "./Testimonial.css";
import { Link } from "react-router-dom";

class Testimonial extends Component {
  render() {
    var settings = {
      dots: false,
      arrows: false,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const testimonial = [
      {
        id: 1,
        tsImg: ts1,
        Title: "GF Gordini",
      },
      {
        id: 2,
        tsImg: ts2,
        Title: "Simex",
      },
      {
        id: 3,
        tsImg: ts3,
        Title: "Manitou Attachments",
      },
    ];
    return (
      <div className="wpo-testimonial-area section-padding">
        <div className="container">
          <SectionTitle
            subTitle={""}
            MainTitle={"Nos fournisseurs d'accessoires"}
          />
          <div className="wpo-testimonial-wrap">
            <div className="testimonial-slider owl-carousel">
              <Slider {...settings}>
                {testimonial.map((tesmnl, tsm) => (
                  <div key={tsm} className="slider_container">
                    <Link to={`/accesoires/${tesmnl.id}`}>
                      <img src={tesmnl.tsImg} alt="" />
                    </Link>
                    <Link to={`/accesoires/${tesmnl.id}`}>
                      <h2>{tesmnl.Title}</h2>
                    </Link>
                    {/* <div className="wpo-testimonial-img">
                                            </div>
                                            <div className="wpo-testimonial-info">
                                          </div> */}
                    {/* <div className="wpo-testimonial-top">
                                        </div> */}
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonial;
